import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIEmptyState from 'UIComponents/empty/UIEmptyState';
import UIIllustration from 'UIComponents/image/UIIllustration';
import UIOptimisticNanoProgress from 'UIComponents/progress/UIOptimisticNanoProgress';
import { queryAllExtensionDefinitions } from 'automation-ui-action-features/actions/extension/extensionQueries';
import { createActionCardCounters } from 'automation-ui-action-features/records/recordsUtils';
import BranchName from 'automation-ui-canvas/components/canvas/BranchName';
import FlowCanvasNode from 'automation-ui-canvas/components/canvas/FlowCanvasNode';
import BranchLabel from 'automation-ui-canvas/components/canvas/BranchLabel';
import ActionCardWithNoDetails from 'automation-ui-canvas/containers/enrollment-history/ActionCardWithNoDetails';
import ModeIndicator from 'automation-ui-canvas/containers/enrollment-history/utils/ModeIndicator';
import { wireEnrollmentHistoryPropsFromURL } from 'automation-ui-canvas/containers/enrollment-history/wireEnrollmentHistoryPropsFromURL';
import { wireFlowByVersion } from 'automation-ui-canvas/containers/enrollment-history/wireFlowByVersion';
import PannableDecorator from 'automation-ui-canvas/decorators/PannableDecorator';
import ZoomableDecorator from 'automation-ui-canvas/decorators/ZoomableDecorator';
import { getActionOutputsForTargetActionById } from 'automation-ui-canvas/flow/records/Flow/flowUtils';
import { trackEvent } from 'automation-ui-canvas/utils/trackingUtils';
import { getEnrollmentHistoryListUrl } from 'automation-ui-canvas/utils/urls';
import { wireAuthConsumer } from 'automation-ui-core/context/AuthContext';
import { attachWrappedComponent } from 'automation-ui-core/decoratorUtils';
import * as SpecialActionIds from 'automation-ui-flow-core/canvas/SpecialActionIds';
import { getFlowEditRoute, parseLocation } from 'automation-ui-routing/utils';
import Trackables from 'automation-ui-usage-tracking/Trackables';
import isEmpty from 'hs-lodash/isEmpty';
import { Component, createRef } from 'react';
import { NavMarker } from 'react-rhumb';
import { withRouter } from 'react-router-dom';
import getComponentName from 'react-utils/getComponentName';
import { compose } from 'redux';
import styled from 'styled-components';
import { MessageComponent } from 'automation-ui-canvas/containers/enrollment-conversion/EnrollmentConversionMessage';
import EndMarker from 'automation-ui-canvas/components/common/EndMarker';
import BranchDescription from 'automation-ui-canvas/components/canvas/BranchDescription';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledCanvas = styled.div.withConfig({
  displayName: "FlowCanvasEnrollmentListDecorator__StyledCanvas",
  componentId: "mellql-0"
})(["height:100%;"]);
const StyledUIOptimisticNanoProgress = styled(UIOptimisticNanoProgress).withConfig({
  displayName: "FlowCanvasEnrollmentListDecorator__StyledUIOptimisticNanoProgress",
  componentId: "mellql-1"
})(["position:absolute;top:0;left:0;right:0;"]);
function getComposedCanvas() {
  return PannableDecorator(
  // @ts-expect-error ZoomableDecorator expects StyledCanvas to have its required props, but it's just a div
  // and the required props aren't wired until ComposedCanvas is used in FlowCanvasBase. Not sure if real error or not
  ZoomableDecorator({
    WrappedComponent: StyledCanvas
  }));
}
export default function FlowCanvasEnrollmentListDecorator(WrappedComponent, centerOnMount) {
  const componentName = getComponentName(WrappedComponent);
  class FlowCanvasEnrollmentList extends Component {
    constructor(...args) {
      super(...args);
      this.handleGetActionOutputsForTargetActionById = (targetActionId, isNew) => {
        const {
          flow,
          allOutputsByActionTypeId,
          instanceOutputsByActionId
        } = this.props;
        return getActionOutputsForTargetActionById({
          flow: flow,
          allOutputsByActionTypeId,
          instanceOutputsByActionId,
          targetActionId,
          isNewAction: isNew
        });
      };
      this.onSelectAction = actionId => {
        var _searchParams$get$spl, _searchParams$get;
        const {
          history,
          flowId
        } = this.props;
        const currentAction = actionId.toString();
        const searchParams = new URLSearchParams(history.location.search);
        const currentFilteredActions = (_searchParams$get$spl = (_searchParams$get = searchParams.get('actions')) === null || _searchParams$get === void 0 ? void 0 : _searchParams$get.split(',')) !== null && _searchParams$get$spl !== void 0 ? _searchParams$get$spl : [];
        // Removes the current action from the list if it's already in the list
        if (currentFilteredActions.includes(currentAction)) {
          currentFilteredActions.splice(currentFilteredActions.indexOf(currentAction), 1);
        } else {
          currentFilteredActions.push(currentAction);
        }
        // update the URL with the new list of actions
        if (currentFilteredActions.length === 0) {
          searchParams.delete('actions');
        } else {
          searchParams.set('actions', currentFilteredActions.join());
        }
        trackEvent(Trackables.PERFORMANCE_HISTORY_CLICK_WORKFLOW_NODE, {
          subscreen: 'enrollment-list',
          actionType: currentAction
        });
        history.replace({
          pathname: getEnrollmentHistoryListUrl({
            flowId
          }),
          search: searchParams.toString()
        });
      };
      this.onRenderCanvasNode = ({
        id,
        width,
        height
      }) => {
        var _searchParams$get$spl2, _searchParams$get2, _searchParams$get$spl3, _searchParams$get3;
        const {
          flow,
          isMulti,
          history,
          allExtensionDefinitionsQuery
        } = this.props;
        let clickable = true;
        if (!flow) {
          return null;
        }
        if (id === SpecialActionIds.ENROLLMENT || id === SpecialActionIds.GO_TO) {
          clickable = false;
        }
        const searchParams = new URLSearchParams(history.location.search);
        const currentFilteredActions = (_searchParams$get$spl2 = (_searchParams$get2 = searchParams.get('actions')) === null || _searchParams$get2 === void 0 ? void 0 : _searchParams$get2.split(',')) !== null && _searchParams$get$spl2 !== void 0 ? _searchParams$get$spl2 : [];
        const isSelected = currentFilteredActions.includes(id.toString());
        const changedActions = (_searchParams$get$spl3 = (_searchParams$get3 = searchParams.get('changedActions')) === null || _searchParams$get3 === void 0 ? void 0 : _searchParams$get3.split(',')) !== null && _searchParams$get$spl3 !== void 0 ? _searchParams$get$spl3 : [];
        if (changedActions.includes(id.toString())) {
          var _allExtensionDefiniti, _allExtensionDefiniti2;
          const extensionDefinitions = (_allExtensionDefiniti = (_allExtensionDefiniti2 = allExtensionDefinitionsQuery.data) === null || _allExtensionDefiniti2 === void 0 ? void 0 : _allExtensionDefiniti2.allExtensionDefinitions) !== null && _allExtensionDefiniti !== void 0 ? _allExtensionDefiniti : {};
          return /*#__PURE__*/_jsx(ActionCardWithNoDetails, {
            nodeId: id,
            flow: flow,
            extensionDefinitions: extensionDefinitions,
            clickable: clickable,
            isSelected: isSelected,
            width: width,
            height: height,
            showIcon: !isMulti,
            borderStyle: isSelected ? 'selected' : undefined,
            onClick: () => this.onSelectAction(id)
          });
        }
        return /*#__PURE__*/_jsx(FlowCanvasNode, {
          id: id,
          width: width,
          height: height,
          isSelected: isSelected,
          clickable: clickable,
          flow: flow,
          readOnly: true,
          showIcon: !isMulti,
          onSelectNode: this.onSelectAction,
          getActionOutputsForTargetActionById: this.handleGetActionOutputsForTargetActionById,
          borderStyle: isSelected ? 'selected' : undefined
        });
      };
      this.onRenderBranchName = edgeId => {
        const {
          flow
        } = this.props;
        return /*#__PURE__*/_jsx(BranchLabel, {
          branchLabelHeaderText: /*#__PURE__*/_jsx(BranchName, {
            flow: flow,
            edgeId: edgeId,
            handleGetActionOutputsForTargetActionById: this.handleGetActionOutputsForTargetActionById
          }),
          branchDescription: /*#__PURE__*/_jsx(BranchDescription, {
            flow: flow,
            edgeId: edgeId
          }),
          hideFooter: true
        });
      };
      this.onRenderEndMarker = ({
        edgeId
      }) => {
        const {
          flow
        } = this.props;
        return /*#__PURE__*/_jsx(EndMarker, {
          flow: flow,
          edgeId: edgeId,
          hideFooter: true
        });
      };
      this.getComposedProps = () => {
        const {
          flow,
          canvasScrollElementRef
        } = this.props;
        return {
          flow: flow,
          canvasScrollElementRef,
          onSelectAction: this.onSelectAction,
          ComposedCanvas: this.ComposedCanvas,
          readOnlyOverride: true,
          centerOnMount,
          TopContent: this.renderTopContent(),
          onRenderCanvasNode: this.onRenderCanvasNode,
          onRenderBranchName: this.onRenderBranchName,
          onRenderEndMarker: this.onRenderEndMarker
        };
      };
      this.renderTopContent = () => {
        const {
          history
        } = this.props;
        const searchParams = new URLSearchParams(history.location.search);
        const currentFilteredActions = searchParams.get('actions');
        if (currentFilteredActions) {
          return /*#__PURE__*/_jsx(MessageComponent, {
            title: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "automation.enrollmentHistory.messages.filterChoices.text"
            }),
            tooltipContent: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "automation.enrollmentHistory.messages.filterChoices.tooltip"
            })
          });
        }
      };
      this.ComposedCanvas = getComposedCanvas();
      this.headerRef = /*#__PURE__*/createRef();
      this.state = {
        actionCardCountersMap: {}
      };
    }
    static getDerivedStateFromProps(props, state) {
      const {
        flow
      } = props;
      const {
        actionCardCountersMap
      } = state;
      if (!flow) {
        return null;
      }
      const countersMap = isEmpty(actionCardCountersMap) ? createActionCardCounters(flow.actions, flow.getFirstActionId()) : actionCardCountersMap;
      return {
        actionCardCountersMap: countersMap
      };
    }
    renderContent() {
      const {
        flow,
        location,
        allExtensionDefinitionsQuery
      } = this.props;
      const parsedQuery = parseLocation(location);
      if (parsedQuery.showVersions !== 'true') {
        return /*#__PURE__*/_jsx(UIEmptyState, {
          titleText: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "automation.enrollmentHistory.noVersionEmptyState.title"
          }),
          primaryContent: /*#__PURE__*/_jsx("div", {
            children: /*#__PURE__*/_jsx("p", {
              children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
                message: "automation.enrollmentHistory.noVersionEmptyState.description"
              })
            })
          }),
          secondaryContent: /*#__PURE__*/_jsx(UIIllustration, {
            name: "errors/map",
            width: "40%"
          })
        });
      }
      if (!flow || allExtensionDefinitionsQuery.loading) {
        return /*#__PURE__*/_jsx(StyledUIOptimisticNanoProgress, {
          value: 10
        });
      }
      return /*#__PURE__*/_jsx(WrappedComponent, Object.assign({}, this.props, this.getComposedProps()));
    }
    render() {
      const {
        history,
        flowId
      } = this.props;
      return /*#__PURE__*/_jsxs(NavMarker, {
        name: "ENROLLMENT_HISTORY_LIST_CANVAS",
        children: [/*#__PURE__*/_jsx(ModeIndicator, {
          onCancel: () => {
            trackEvent(Trackables.PERFORMANCE_HISTORY_CLOSE_MODE_INDICATOR);
            history.push(getFlowEditRoute(flowId));
          },
          dataTestId: "enrollment-history-mode-indicator",
          modeTitle: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "automation.enrollmentHistory.mode.title"
          })
        }), this.renderContent()]
      });
    }
  }
  const ConnectedFlowCanvasEnrollmentList = compose(wireAuthConsumer, withRouter, wireEnrollmentHistoryPropsFromURL, wireFlowByVersion, queryAllExtensionDefinitions // Requires flowSourceApp and flowObjectTypeId
  )(FlowCanvasEnrollmentList);
  ConnectedFlowCanvasEnrollmentList.displayName = `ConnectedFlowCanvasEnrollmentList(${componentName})`;
  attachWrappedComponent(ConnectedFlowCanvasEnrollmentList, WrappedComponent);
  return ConnectedFlowCanvasEnrollmentList;
}